
export default {
  layout: 'academy_client',
  head() {
    return {
      title: 'Zápis na školení | 3D Fitness Academy'
    }
  },
}
